export default "__VITE_ASSET__BCqp6zUF__"